
// src/reducers/menus-reducer.js

import {
  INIT_MENU,
  SORT_MENU,
  SET_FREE_MENU,
  SET_NOT_FREE_MENU,
  SET_FLASH_NEW_FREE_GROUP_ID,
  EXPAND_DIVISION,
  COLLAPSE_DIVISION,
  COLLAPSE_DIVISION_SORT,
  EXPAND_DIVISION_NOT_SET_GROUP,
  EXPAND_DIVISION_SORT,
  EXPAND_DIVISION_SORT_NOT_SET_GROUP,
  SET_SORTING_MENU_POSITION,
  applyMenuPosition,
} from '../actions/menus'

const initialState = {
  items: [],
  flashNewFreeGroupId: undefined,
  sortingMenu: undefined,
  expandedDivisions: [],
  expandedDivisionSort: [],
  canExpandDivNotSetGroup: false,
  canExpandDivSortNotSetGroup: false
}
const MaxItemPerMenu = 100

export default function menusReducer(state = initialState, action = {}) {
  switch(action.type) {
    case INIT_MENU:
      const divisionsMenu = [...action.results].filter((item) => item.type === 'division')
      return Object.assign({}, state, {
        items: action.results.sort((item1, item2) => item1.position - item2.position),
        canExpandDivNotSetGroup: state.canExpandDivNotSetGroup || divisionsMenu.length === 0,
        canExpandDivSortNotSetGroup: state.canExpandDivSortNotSetGroup || divisionsMenu.length === 0,
        expandedDivisions: divisionsMenu.length === 1 ? [divisionsMenu[0].item_id] : state.expandedDivisions,
        expandedDivisionSort: divisionsMenu.length === 1 ? [divisionsMenu[0].item_id] : state.expandedDivisionSort,
      })
    case SORT_MENU: {
      let {oldPosition, newPosition} = action.results
      const fromMenu =  state.items.find(item => item.position == oldPosition)
      const toMenu =  state.items.find(item => item.position == newPosition)
      if (!fromMenu || !toMenu || fromMenu.type != toMenu.type)
        return Object.assign({}, state, {
          items: [...state.items]
        })
      if (fromMenu.type == 'group' && Math.floor(newPosition / MaxItemPerMenu) != Math.floor(oldPosition / MaxItemPerMenu) )
        return Object.assign({}, state, {
          items: [...state.items]
        })

      let newItems = [...state.items].filter(item => item.position != oldPosition)
      const updatedPosition = newPosition < oldPosition ? (newPosition - 0.5) : (newPosition + 0.5)
      newItems.push({...fromMenu, position: updatedPosition})
      newItems.sort((item1, item2) => item1.position - item2.position)
      applyMenuPosition(newItems)
      return Object.assign({}, state, {
        items: newItems
      })
    }

    case SET_FREE_MENU: {
      const {position} = action.results
      const fromMenu = state.items.find(item => item.position == position)
      let newItems = [...state.items].filter(item => item.type != 'group' || item.item_id != fromMenu.item_id)
      const newPosition = Math.floor(position / MaxItemPerMenu) * MaxItemPerMenu - 1
      newItems.push({...fromMenu, is_free: true, position: newPosition, parent_id: null})
      newItems.sort((item1, item2) => item1.position - item2.position)
      applyMenuPosition(newItems)
      return Object.assign({}, state, {
        items: newItems
      })
    }

    case SET_NOT_FREE_MENU: {
      const {position, groupDivisionIds} = action.results
      const fromMenu = state.items.find(item => item.position == position)
      let newItems = [...state.items].filter(item => item.type != 'group' || item.item_id != fromMenu.item_id)
      groupDivisionIds.forEach(division_id => {
        const sameParentItems = newItems.filter(item => item.parent_id == division_id)
        const parentItem = newItems.find(item => item.item_id == division_id)
        const newPosition = sameParentItems.length > 0 ? sameParentItems.slice(-1)[0].position + 1 : parentItem.position + 1
        newItems.push({...fromMenu, is_free: false, position: newPosition, parent_id: division_id})
      })
      return Object.assign({}, state, {
        items: newItems.sort((item1, item2) => item1.position - item2.position)
      })
    }
    case SET_FLASH_NEW_FREE_GROUP_ID:
      return Object.assign({}, state, {
        flashNewFreeGroupId: action.results
      })
    case EXPAND_DIVISION:
      let expandedDivisions = [...state.expandedDivisions]
      expandedDivisions.push(action.results)
      return Object.assign({}, state, {
        expandedDivisions
      })
    case EXPAND_DIVISION_SORT:
      let expandedDivisionSort = [...state.expandedDivisionSort]
      expandedDivisionSort.push(action.results)
      return Object.assign({}, state, {
        expandedDivisionSort
      })
    case EXPAND_DIVISION_NOT_SET_GROUP:
      return Object.assign({}, state, {
        canExpandDivNotSetGroup: !state.canExpandDivNotSetGroup
      })
    case EXPAND_DIVISION_SORT_NOT_SET_GROUP:
      return Object.assign({}, state, {
        canExpandDivSortNotSetGroup: !state.canExpandDivSortNotSetGroup
      })
    case COLLAPSE_DIVISION:
      return Object.assign({}, state, {
        expandedDivisions: state.expandedDivisions.filter(division_id => division_id != action.results)
      })
    case COLLAPSE_DIVISION_SORT:
      return Object.assign({}, state, {
        expandedDivisionSort: state.expandedDivisionSort.filter(division_id => division_id != action.results)
      })
    case SET_SORTING_MENU_POSITION: {
      const position = action.results
      const menu = state.items.find(item => item.position == position)
      return Object.assign({}, state, {
        sortingMenu: menu
      })
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/menus-reducer.js